// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dev-only: twentytwentysix color inventory */
.t26-color-inv {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 20px 48px;
  color: #2f2b32;
  font-family: system-ui, sans-serif;
}

.t26-color-inv__header {
  margin-bottom: 28px;
}

.t26-color-inv__title {
  margin: 0 0 8px;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.t26-color-inv__meta {
  margin: 0 0 12px;
  font-size: 0.85rem;
  color: #5b565d;
  line-height: 1.5;
}

.t26-color-inv__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 20px;
}

.t26-color-inv__card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

.t26-color-inv__swatch {
  aspect-ratio: 1;
  width: 100%;
  border: none;
  padding: 0;
  cursor: pointer;
  display: block;
  box-sizing: border-box;
}

.t26-color-inv__swatch--light {
  border: 1px solid rgba(0, 0, 0, 0.18);
}

.t26-color-inv__body {
  padding: 10px 12px 12px;
  text-align: center;
}

.t26-color-inv__label {
  margin: 0 0 6px;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.25;
  word-break: break-word;
}

.t26-color-inv__var {
  margin: 0 0 4px;
  font-size: 0.7rem;
  font-family: ui-monospace, monospace;
  color: #6b666b;
  word-break: break-all;
}

.t26-color-inv__value {
  margin: 0;
  font-size: 0.68rem;
  font-family: ui-monospace, monospace;
  color: #433d43;
  word-break: break-all;
}

.t26-color-inv__sources {
  margin: 8px 0 0;
  padding: 0;
  font-size: 0.62rem;
  color: #8a858c;
  text-align: left;
  list-style: none;
  max-height: 72px;
  overflow-y: auto;
}

.t26-color-inv__sources li {
  margin: 2px 0;
  word-break: break-all;
}

.t26-color-inv__toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 16px;
  background: #2f2b32;
  color: #fff;
  font-size: 0.8rem;
  border-radius: 8px;
  z-index: 10000;
  opacity: 0.95;
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/pages/TwentytwentysixColorInventoryPage.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf","sourcesContent":["/* Dev-only: twentytwentysix color inventory */\n.t26-color-inv {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 24px 20px 48px;\n  color: #2f2b32;\n  font-family: system-ui, sans-serif;\n}\n\n.t26-color-inv__header {\n  margin-bottom: 28px;\n}\n\n.t26-color-inv__title {\n  margin: 0 0 8px;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.t26-color-inv__meta {\n  margin: 0 0 12px;\n  font-size: 0.85rem;\n  color: #5b565d;\n  line-height: 1.5;\n}\n\n.t26-color-inv__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 20px;\n}\n\n.t26-color-inv__card {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);\n}\n\n.t26-color-inv__swatch {\n  aspect-ratio: 1;\n  width: 100%;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: block;\n  box-sizing: border-box;\n}\n\n.t26-color-inv__swatch--light {\n  border: 1px solid rgba(0, 0, 0, 0.18);\n}\n\n.t26-color-inv__body {\n  padding: 10px 12px 12px;\n  text-align: center;\n}\n\n.t26-color-inv__label {\n  margin: 0 0 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  line-height: 1.25;\n  word-break: break-word;\n}\n\n.t26-color-inv__var {\n  margin: 0 0 4px;\n  font-size: 0.7rem;\n  font-family: ui-monospace, monospace;\n  color: #6b666b;\n  word-break: break-all;\n}\n\n.t26-color-inv__value {\n  margin: 0;\n  font-size: 0.68rem;\n  font-family: ui-monospace, monospace;\n  color: #433d43;\n  word-break: break-all;\n}\n\n.t26-color-inv__sources {\n  margin: 8px 0 0;\n  padding: 0;\n  font-size: 0.62rem;\n  color: #8a858c;\n  text-align: left;\n  list-style: none;\n  max-height: 72px;\n  overflow-y: auto;\n}\n\n.t26-color-inv__sources li {\n  margin: 2px 0;\n  word-break: break-all;\n}\n\n.t26-color-inv__toast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 16px;\n  background: #2f2b32;\n  color: #fff;\n  font-size: 0.8rem;\n  border-radius: 8px;\n  z-index: 10000;\n  opacity: 0.95;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
